import { trimStart } from 'lodash';
import getOuterUrl from './get-outer-url';
import { readableUrl } from '../../services/uri';
export var encodeQuery = function (query) { return encodeURIComponent(query.toLowerCase().replace(/#/g, '.hash.')); };
export var decodeQuery = function (query) { return decodeURIComponent(query).replace(/\.hash\./g, '#'); };
export var createHashtagPath = function (decoratedText) {
    var hashtag = "#" + trimStart(decoratedText, '#');
    return readableUrl("/search/" + encodeQuery(hashtag));
};
export var createHashtagHref = function (decoratedText, sectionUrl) {
    return getOuterUrl(createHashtagPath(decoratedText), sectionUrl);
};
export var createAMPHashtagHref = function (sectionUrl) { return function (decoratedText) {
    return getOuterUrl(createHashtagPath(decoratedText), sectionUrl);
}; };
